interface ModeType {
  key: string;
  id: string;
  text1: string;
  text2: string;
}

const modeData: ModeType[] = [
  {
    key: "entrainement",
    id: "Entraînement",
    text1: `Ici, pas de compétition, le score est collectif !`,
    text2: `Idéal pour découvrir le contenu à votre rythme.`,
  },
  {
    key: "classique",
    id: "Mode classique",
    text1: `Ici, on cherche à obtenir un certain nombre de points ! Vous choisissez le thème et la difficulté des questions.`,
    text2: `Idéal pour créer une dynamique de challenge entre les joueurs !`,
  },
  {
    key: "expert",
    id: "Mode Expert",
    text1: `Ici, on ne choisit ni le thème ni le niveau de difficulté. C’est le hasard qui décide !`,
    text2: `Idéal pour créer une dynamique de challenge entre les joueurs !`,
  },
];

export { modeData };
